import { createListenerMiddleware } from '@reduxjs/toolkit';
import { RefreshTokenRequest } from '../features/Auth/AuthSlice';
import Cookies from 'js-cookie';
import moment from 'moment';

const RefreshMiddleware = createListenerMiddleware();

const skipActions = [
  'auth/refresh',
  'auth/refresh/pending',
  'auth/refresh/fulfilled',
  'auth/refresh/rejected'
];

RefreshMiddleware.startListening({
  actionCreator: '*',
  effect: async (action, listenerApi) => {
    const { auth } = listenerApi.getState();
    if (!skipActions.includes(action.type) && auth.isAuthenticated) {
      let expiryTime = Cookies.get('expires_in');
      if (expiryTime) {
        const currentTime = moment();
        expiryTime = moment(expiryTime);
        const sessionValidity = expiryTime.diff(currentTime, 'm');
        if (sessionValidity <= 10 && !auth.isRefreshCalled) {
          listenerApi.dispatch(RefreshTokenRequest());
        }
      }
    }
  }
});

export default RefreshMiddleware;
